// Custom scripts

$(function() {

    $(document).on('mouseover', '.account-link', function () {
        $(this).find('.dropdown-menu.active').show();
        console.log("hovered");
    })

    $('body').on('click', function(e) {
        if($(e.target).closest('.dropdown-menu.active').length == 0) {
           $('.dropdown-menu.active').hide();
        }
    });

    $("nav.menuContainer").accessibleMegaMenu({
        /* prefix for generated unique id attributes, which are required 
           to indicate aria-owns, aria-controls and aria-labelledby */
        uuidPrefix: "accessible-megamenu",
        
        /* css class used to define the megamenu styling */
        menuClass: "nav",
        
        /* css class for a top-level navigation item in the megamenu */
        topNavItemClass: "navItem",
        
        /* css class for a megamenu panel */
        panelClass: "menuDropdown",
        
        /* css class for a group of items within a megamenu panel */
        panelGroupClass: "velaMenuLinks",
        
        /* css class for the hover state */
        hoverClass: "hover",
        
        /* css class for the focus state */
        focusClass: "focus",
        
        /* css class for the open state */
        openClass: "open"
    });
    // gift wrapping
    var giftWrapping = $('.gift-wrapping');
    if (giftWrapping.length) {
        var id = $('[data-gift-wrap-id]').val();
        // check if authority-to-leave is checked
        // $.get("/cart.json", function(data, status){

        //     if (status == 'success') {
        //         var cartItems = data.items;
        //         var found = cartItems.find(function (item) {
        //             return item.id == id;
        //         });

        //         if(found){
        //             $('#gift-wrap-checkbox').prop('checked', true);
        //             $('[data-gift-wrap-id] + div').addClass('active');

        //         }else{
        //             $('#gift-wrap-checkbox').prop('checked', false);
        //             $('[data-gift-wrap-id] + div').removeClass('active');
        //         }

        //     }
        // });

        $(document).on('change','#gift-wrap-checkbox',function() {

            if(this.checked) {
                $.post('/cart/update.js', {updates: { [id]: 1 }});
                setTimeout(() => {
                    location.reload();
                }, 500);

            }else{
                $.post('/cart/update.js', {updates: { [id]: 0 }});
                setTimeout(() => {
                    location.reload();
                }, 500);

            }

        });


    }

    /* Currency Form */
    function currencyFormSubmit(event) {
        event.target.form.submit();
    } 
    
    document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
        element.addEventListener('change', currencyFormSubmit);
    });
    
    if ($('.shg-product-price').length > 0 && typeof currencySymbol !== 'undefined') {
        setTimeout(function(){ 
            $('.shg-product-price').each(function() {
                var _this = $(this)
                var text = _this.text()
                var formattedPrice = text.replace(text.charAt(0), currencySymbol)
                _this.text(formattedPrice)
            })
        }, 3000);
    }

    /* Wishlist @ $2 App Custom Scripts */
    $('#addToWishlist').on('click', function() {
        if (!$(this).hasClass('added')) {
            $('body').find('.iWishAdd').trigger('click');
            $(this).addClass('added');
        }
    });

    $(window).on('load', function() {
        setTimeout(function() {
            if ($('body').find('a.iWishAdd.iwishAdded').length > 0) {
                $('#addToWishlist').addClass('added');
            }
        }, 500);
    });


    // Klaviyo Integration in Register page
    if($('.formAccount.register').length == 1) {
        $(".register-button").click(function(e) {
            if ($("#marketing").is(':checked')) { 

                var listId = $('input#ListID').val(); 
                var email = $('input#Email').val(); 
                var firstname = $('input#FirstName').val(); 
                var lastname = $('input#LastName').val(); 
                var settings = { 
                    "async": true, 
                    "crossDomain": true, 
                    "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
                    "method": "POST", 
                    "headers": { 
                    "content-type": "application/x-www-form-urlencoded", 
                    "cache-control": "no-cache" 
                    }, 
                "data": {
                    "g": listId, 
                    "email": email, 
                    "$fields": "$source, $first_name, $last_name",
                    "$source": "Account Creation", 
                    "$first_name": firstname,
                    "$last_name": lastname 
                    }
                }; 

                $.ajax(settings).done(function(response) { 
                    console.log(response); 
                })
            }  
        })
    }
});